'use client';

import Script from 'next/script';

export default function BBHChat() {
  return (
    <Script
      src="https://chatbox-embed-sdk.botbanhang.vn/dist/sdk.min.js"
      strategy="afterInteractive"
      onLoad={() => {
        if (typeof window !== 'undefined' && (window as any).BBH) {
          (window as any).BBH.init({ page_id: '597144796220935' });
        }
      }}
    />
  );
}